import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { MetadataService } from '../metadata/metadata.service';
import { Subject } from 'rxjs';
import { FilterSettings } from './model/filterSettings';
import { FilterStatus } from './model/filterStatuts';
import { SearchBarService } from '../search-bar/search-bar.service';
import { DEFAULT_METADATA } from '../../../app/services/metadata/model/defaultMetadata';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  private _filterSettings: FilterSettings;
  private _filterStatus: FilterStatus;
  private _filterStatusDefault: FilterStatus;
  private _filterSettingsDefault: FilterSettings;
  private _alertFilterToggleStatus: boolean = undefined;

  constructor(public http: HttpClient,
              private logger: NGXLogger,
              private metadataService: MetadataService,
              private searchBarService: SearchBarService) {

   this.logger.debug('Hello FilterService Service');

   

  }

  _filterSettingsSource: Subject<FilterSettings> = new Subject();
  get filterSettingsSource(): Subject<FilterSettings> {
    return this._filterSettingsSource;
  }
  set filterSettingsSource(src: Subject<FilterSettings>) {
    this.filterSettingsSource = src;
  }

  setFilterSettings(filterSettings: FilterSettings) {
    this._filterSettings = filterSettings;
    this._filterSettingsSource.next(filterSettings);
  }

  getFilterSettings() {
    return this._filterSettings;
  }

  setFilterStatus(filterStatus: FilterStatus) {
    this._filterStatus = filterStatus;
  }

  getFilterStatus() {
    return this._filterStatus;
  }

  getFilterStatusDefault() {
    return this._filterStatusDefault;
  }

  getFilterSettingsDefault() {

    return this. _filterSettingsDefault;
  }
  getIsFilterDefault() {
    return JSON.stringify(this._filterStatusDefault) === JSON.stringify(this._filterStatus);
  }

  setDefaultFilterOptions() {
    this._filterStatus = this._filterStatusDefault;
    this._filterSettings = this._filterSettingsDefault;
  }

  initFilterService() {
    const provider = DEFAULT_METADATA.providers.find(p => p.name === 'FilterService');
    
    // Settings
    const sVar = provider.variables.find(v => v.name === '_filterSettingsDefault');
    const remoteS = this.metadataService.getProviderVariableData('FilterService', '_filterSettingsDefault');
    this._filterSettingsDefault = (remoteS && remoteS.value) ? remoteS.value : sVar.value;

    // Status
    const stVar = provider.variables.find(v => v.name === '_filterStatusDefault');
    const remoteSt = this.metadataService.getProviderVariableData('FilterService', '_filterStatusDefault');
    this._filterStatusDefault = (remoteSt && remoteSt.value) ? remoteSt.value : stVar.value;

    this.setDefaultFilterOptions();
  }

  setAlertFilterToggle(status){
    this._alertFilterToggleStatus = status;
  }

  getAlertFilterToggle(){
    return this._alertFilterToggleStatus;
  }
}
